import {
    Box,
    Card,
    IconButton,
    makeStyles,
    Typography,
} from '@material-ui/core';
import React from 'react';
import type { VedleggResponse } from '../services/rtkApi';
import { processApiName } from '../config';
import { generateApiRoute } from '@klp/core/api/helpers';
import { FileDownload } from '@klp/filedownload';
import { IconName, Illustration } from '@klp/design/Illustrations';

const useStyles = makeStyles((theme) => ({
    card: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    fileInfo: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    iconButton: {
        marginLeft: theme.spacing(1),
    },
    actionButtons: {
        display: 'flex',
        alignItems: 'center',
    },
}));

export const Vedlegg = ({
    vedlegg,
    isReadOnly,
    onDeleteRow,
    isDeleting,
}: {
    vedlegg: VedleggResponse;
    isReadOnly: boolean;
    onDeleteRow: () => void;
    isDeleting: boolean;
}) => {
    const classes = useStyles();
    const canPreviewAttachment =
        vedlegg.type &&
        (vedlegg.type.startsWith('image/') ||
            vedlegg.type === 'application/pdf');

    return (
        <Card className={classes.card}>
            <Box className={classes.fileInfo}>
                <Typography variant="body1" noWrap={true}>
                    {vedlegg.name}
                </Typography>
                <Typography variant="body2" color="textSecondary" noWrap={true}>
                    {vedlegg.type}
                </Typography>
            </Box>
            <Box className={classes.actionButtons}>
                {canPreviewAttachment && (
                    <FileDownload
                        path={generateApiRoute([
                            processApiName,
                            'vedlegg',
                            vedlegg.id,
                        ])}
                        name={vedlegg.name}
                        preview={true}
                        showNotifications={false}
                    >
                        <IconButton
                            color="primary"
                            className={classes.iconButton}
                        >
                            <Illustration
                                icon={IconName.SEARCH}
                                klpPalette="primary"
                                klpColor="main"
                            />
                        </IconButton>
                    </FileDownload>
                )}
                <FileDownload
                    path={generateApiRoute([
                        processApiName,
                        'vedlegg',
                        vedlegg.id,
                    ])}
                    name={vedlegg.name}
                    showNotifications={false}
                >
                    <IconButton color="primary" className={classes.iconButton}>
                        <Illustration
                            icon={IconName.DOWNLOAD}
                            klpPalette="primary"
                            klpColor="main"
                        />
                    </IconButton>
                </FileDownload>
                {!isReadOnly && (
                    <IconButton
                        disabled={isReadOnly || isDeleting}
                        onClick={onDeleteRow}
                        color="secondary"
                        className={classes.iconButton}
                    >
                        <Illustration
                            icon={IconName.DELETE}
                            klpPalette="primary"
                            klpColor="main"
                        />
                    </IconButton>
                )}
            </Box>
        </Card>
    );
};
